import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=aa4c06c2&scoped=true"
import script from "./thumbnail.vue?vue&type=script&lang=js"
export * from "./thumbnail.vue?vue&type=script&lang=js"
import style0 from "./thumbnail.vue?vue&type=style&index=0&id=aa4c06c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4c06c2",
  null
  
)

export default component.exports